<template lang="pug">
    section.purchase-step(v-if="form.purchaser.billingAddress")
        .hidden
            el-form-item(prop="purchaser.gender")
            el-form-item(prop="purchaser.first_name")
            el-form-item(prop="purchaser.last_name")
            el-form-item(prop="purchaser.email")

            el-form-item(prop="purchaser.billingAddress.street")
            el-form-item(prop="purchaser.billingAddress.zipcode")
            el-form-item(prop="purchaser.billingAddress.city")
            el-form-item(prop="purchaser.billingAddress.country")

        .find-customer-panel
            el-autocomplete.is-full-width(
                v-model="search"
                value-key="name"
                :fetch-suggestions="autocomplete"
                :placeholder="$t('Find customer...')"
                @select="selectExistingMember"
                @keydown.escape.native="resetSearch"
                @keydown.enter.native.prevent
                @clear="resetSearch"
            )
                template(slot="prefix")
                    i.fas.el-icon-fa-magnifying-glass
                template(slot-scope="{ item }")
                    .autocomplete-item
                        .flex-row
                            .customer-nr(v-if="item.customer") \#{{ item.customer.nr }}
                            b.name {{ item.name }}
                            .email {{ item.email }}

        .flex-row
            el-form-item(:label="$t('Salutation')" prop="purchaser.gender")
                el-select.is-full-width(
                    placeholder=""
                    clearable
                    v-model="form.purchaser.gender"
                )
                    el-option(:label="$t('Mr.')" value="M")
                    el-option(:label="$t('Mrs.')" value="F")
                    el-option(:label="$t('Undefined')" value="X")
            el-form-item.grow(:label="$t('First name')" prop="purchaser.first_name")
                el-input(v-model="form.purchaser.first_name" maxlength="255" show-word-limit)
            el-form-item.grow(:label="$t('Last name')" prop="purchaser.last_name")
                el-input(v-model="form.purchaser.last_name" maxlength="255" show-word-limit)
        .flex-row
            el-form-item.grow(:label="$t('Email')" prop="purchaser.email")
                el-input(v-model="form.purchaser.email" maxlength="255" show-word-limit)
            el-form-item.grow(:label="$t('Phone')" prop="purchaser.phone")
                el-input(v-model="form.purchaser.phone" maxlength="255" show-word-limit)
        template(v-if="!selectedCustomer")
            .flex-row
                el-form-item(label=" " prop="purchaser.create")
                    el-checkbox(v-model="create" border) {{ $t('Create new customer') }}
                transition(name="slide-decent-vertical")
                    el-form-item.grow(v-if="create" :label="$t('Customer Nr')" prop="purchaser.customer.nr")
                        el-input(v-model="form.purchaser.customer.nr")
                transition(name="slide-decent-vertical")
                    el-form-item.grow(v-if="create" :label="$t('Password')" prop="purchaser.password")
                        el-input(
                            v-model="form.purchaser.password"
                            type="password"
                            suffix-icon="el-icon-fa-key fas"
                        )
            transition(name="slide-decent-vertical")
                .flex-row(v-if="create")
                    el-form-item.customer-group.grow(:label="$t('Customer Group')" prop="tags")
                        el-select.is-full-width(
                            placeholder=""
                            v-model="form.purchaser.customer.customerGroup"
                            valueKey="id"
                        )
                            el-option(
                                v-for="item in options.customerGroup.items"
                                :key="item.id"
                                :label="item.name"
                                :value="item"
                            )
                    .tag-row
                        el-form-item(:label="$t('Tags')" prop="tags")
                            el-tag(
                                v-for="tag in form.purchaser.customer.member.memberTags"
                                closable
                                :key="tag.name"
                                size="large"
                                @close="removeTag(tag)"
                            ) {{ tag.name }}
                            el-autocomplete.input-new-tag(
                                v-if="newTagInputVisible"
                                v-model="newTagInput"
                                ref="newTagInput"
                                value-key="name"
                                :fetch-suggestions="autocompleteTag"
                                :placeholder="$t('Add tag')"
                                @select="selectExistingTag"
                                @keydown.escape.native="resetNewTag"
                                @keydown.enter.native.prevent="addNewTag"
                                @clear="resetNewTag"
                                @blur="blurNewTag"
                                :maxlength="255"
                                show-word-limit
                            )
                            el-button.button-new-tag(
                                v-else
                                type="primary"
                                icon="el-icon-fa-plus fas"
                                @click="showTagInput"
                            ) {{ $t('Add tag') }}

        h3 {{ $t('Billing Address') }}
        .billing-address
            el-form-item(:label="$t('Street')" prop="purchaser.billingAddress.street")
                el-input(v-model="form.purchaser.billingAddress.street" maxlength="255" show-word-limit)
            el-row.no-padding(:gutter="20")
                el-col(:lg="8" :md="8")
                    el-form-item(:label="$t('Zipcode')" prop="purchaser.billingAddress.zipcode")
                        el-input(v-model="form.purchaser.billingAddress.zipcode" maxlength="255" show-word-limit)
                el-col(:lg="16" :md="16")
                    el-form-item(:label="$t('City')" prop="purchaser.billingAddress.city")
                        el-input(v-model="form.purchaser.billingAddress.city" maxlength="255" show-word-limit)
            el-form-item.no-margin(:label="$t('Country')" prop="purchaser.billingAddress.country")
                el-select.is-full-width(
                    placeholder=""
                    filterable
                    v-model="form.purchaser.billingAddress.country"
                    autocomplete="no-fill"
                )
                    el-option(
                        v-for="(label, value) in countries"
                        :key="value"
                        :label="label"
                        :value="value"
                    )
</template>

<i18n>
{
    "de": {
        "Find customer...": "Kunden finden...",
        "Salutation": "Anrede",
        "First name": "Vorname",
        "Last name": "Nachname",
        "Email": "E-Mail",
        "Password": "Passwort",
        "Add tag": "Tag hinzufügen",
        "Customer Nr": "Kunden Nr",
        "Customer Group": "Kundengruppe",
        "Phone": "Telefon",
        "Company": "Firma",
        "Mr.": "Herr",
        "Mrs.": "Frau",
        "Undefined": "Unbekannt",
        "Create new customer": "Neuen Kunden anlegen",
        "Billing Address": "Rechnungsadresse",
        "Street": "Straße",
        "Zipcode": "PLZ",
        "City": "Ort",
        "Country": "Land"
    }
}
</i18n>

<script>
import _ from 'lodash';
import uniqid from 'uniqid';
import { mapGetters } from 'vuex';

import Fuse from 'fuse.js'

import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import de from 'i18n-iso-countries/langs/de.json'

countries.registerLocale(en)
countries.registerLocale(de)

import store from '@/store'

import MemberApi from '@/extensions/restrictedArea/store/api/member';

export default {
    name: 'CustomerStep',
    props: {
        form: {
            type: Object,
            required: true
        },
        rules: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            search: '',
            newTagInputVisible: false,
            newTagInput: '',
        };
    },
    computed: {
        selectedCustomer() {
            const id = _.get(this.form, 'purchaser.customer.id')
            // return id ? id.startsWith('new:') === false : false
            if (!id || id.startsWith('new:')) return false
            else return true
        },
        create: {
            get() {
                return this.form.purchaser.create
            },
            set(value) {
                this.form.purchaser.create = value
                if (value) {
                    const customerGroup = _.get(this.activeCms, 'shop.defaultCustomerGroup');
                    this.$set(this.form.purchaser, 'customer', {
                        id: uniqid('new:'),
                        customerGroup,
                        member: {
                            id: uniqid('new:'),
                            memberTags: []
                        }
                    })
                } else {
                    this.$delete(this.form.purchaser, 'customer')
                }
            }
        },
        countries() {
            return countries.getNames('de')
        },
        autocompleteTagOptions() {
            const tags = _.get(this.form.purchaser, 'customer.member.memberTags') || []
            let options = this.options.memberTag.items
            return options.filter(option => {
                return ! tags.find(tag => tag.name === option.name)
            })
        },
        ...mapGetters({
            options: 'ext_shop_purchase/options',

            // cms
            activeCms: 'activeCms'
            // enabledExtensions: 'enabledExtensions',
        })
    },
    methods: {
        addTag(name) {
            const tags = _.get(this.form.purchaser, 'customer.member.memberTags') || []

            let tag;

            // find existing by name
            if (this.options.memberTag.items.length) {
                const match = this.options.memberTag.items.find(tag => tag.name === name);
                if (match) tag = match;
            }

            // check if tag is already in use
            if (tags.length) {
                const match = tags.find(tag => tag.name === name);
                if (match) return;
            }

            if (name) {
                if (!tag) tag = { name };
                // state.form.tags.push(tag);
                const i = tags.length;
                this.$set(this.form.purchaser.customer.member.memberTags, i, tag);
            }
        },
        removeTag(tag) {
            const tags = _.get(this.form.purchaser, 'customer.member.memberTags') || []
            if (!tags.length) return

            this.form.purchaser.customer.member.memberTags = this.form.purchaser.customer.member.memberTags.filter(el => el.name !== tag.name)
        },
        showTagInput() {
            this.newTagInputVisible = true
            this.$nextTick(() => {
                this.$refs.newTagInput.$refs.input.focus()
            })
        },
        addNewTag() {
            this.addTag(this.newTagInput);
            this.resetNewTag();
            this.$nextTick(this.showTagInput);
        },
        resetNewTag() {
            this.newTagInputVisible = false
            this.newTagInput = ''
        },
        blurNewTag() {
            setTimeout(() => {
                if (this.$refs.newTagInput && this.$refs.newTagInput.$refs.input.focused === false) this.addTag(this.newTagInput);
                this.resetNewTag();
            }, 150);
        },
        autocompleteTag(query, callback) {
            if (! this.autocompleteTagOptions.length || ! query) {
                callback([])
                return false
            }
            const settings = {
                shouldSort: true,
                tokenize: true,
                matchAllTokens: true,
                threshold: 0.3,
                minMatchCharLength: 1,
                keys: ['name'],
            }
            const fuse = new Fuse(this.autocompleteTagOptions, settings)
            const result = _.map(fuse.search(query), el => {
                return el.item
            })
            callback(result)
        },
        selectExistingTag(tag) {
            this.addTag(tag.name);
            this.resetNewTag();
            this.$nextTick(this.showTagInput);
        },

        async autocomplete(query, callback) {
            if (!query) return callback([])

            const members = await MemberApi.autocomplete(this.activeCms.id, query)
                .catch(err => {
                    error = err
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });

                    console.error(err)
                })

            // callback(members.map(member => {
            //     if (member.customer) member.label = `#${member.customer.nr} ${member.name} (${member.email})`
            //     else member.label = `${member.name} (${member.email})`
            //     return member
            // }))

            callback(members)
        },
        selectExistingMember(member) {
            this.search = ''

            if (member.customer) {
                this.$set(this.form.purchaser, 'customer', _.cloneDeep(member.customer))
                this.$set(this.form.purchaser.customer, 'member', _.cloneDeep(member))
                this.$delete(this.form.purchaser.customer.member, 'customer')
            }

            this.$set(this.form.purchaser, 'gender', member.gender)
            this.$set(this.form.purchaser, 'first_name', member.first_name)
            this.$set(this.form.purchaser, 'last_name', member.last_name)
            this.$set(this.form.purchaser, 'email', member.email)
            this.$set(this.form.purchaser, 'phone', member.phone)

            if (member.billingAddress) {
                this.$set(this.form.purchaser, 'billingAddress', _.cloneDeep(member.billingAddress))
            }

            if (member.shippingAddress) {
                this.$set(this.form.purchaser, 'shippingAddress', _.cloneDeep(member.shippingAddress))
            }
        },
        resetSearch() {
            this.search = ''
        }
    },
    mounted() {
        if (!this.form.purchaser.billingAddress) {
            this.form.purchaser.billingAddress = {
                // default_billing address data from member
                id: undefined,
                gender: undefined,
                first_name: undefined,
                last_name: undefined,
                company: undefined,
                street: undefined,
                street_addition: undefined,
                zipcode: undefined,
                city: undefined,
                country: undefined, // ISO-2 code
                type: 'billing',
                latitude: undefined,
                longitude: undefined
            }
        }
    }
};
</script>

<style lang="sass" scoped>
.find-customer-panel
    background: $color-skeleton
    padding: 2rem
    border-radius: 4px
    display: flex
    align-items: center
    justify-content: center
    margin-bottom: 4rem

h3
    font-weight: 300
    // text-align: center

.el-autocomplete::v-deep
    max-width: 600px
    .el-input__prefix
        display: flex
        justify-content: center
        align-items: center
        width: 24px

.autocomplete-item
    padding: 0.5rem 0
    line-height: 1.3
    .flex-row
        align-items: center

.el-tag
    height: 36px
    line-height: 34px

.input-new-tag
    width: 220px

.button-new-tag
    min-width: 220px
    height: 36px

.customer-group
    min-width: 230px

.tag-row .el-form-item
    margin-bottom: 0
    &::v-deep .el-form-item__content
        display: flex
        flex-wrap: wrap
        align-items: center
        gap: 10px
        &:before
            display: none
    .el-tag + .el-tag
        margin-left: 0
</style>
